import { NgModule } from 'ng-metadata/core';
import { DropComponent } from './drop.component';
import { DropToggleDirective } from './drop-toggle.directive';
import { DropContentComponent } from './drop-content.component';
import './drop.scss';

@NgModule({
  declarations: [
    DropComponent,
    DropToggleDirective,
    DropContentComponent,
  ],
})
export class DropModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/common/drop/drop.module.ts